import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from 'recharts';

export const ScoreRadar = ({ scores, size = 260 }) => {
  const data = [
    { axis: 'Performance', value: scores?.performance ?? 0 },
    { axis: 'Consistency', value: scores?.consistency ?? 0 },
    { axis: 'Reliability', value: scores?.reliability ?? 0 },
    { axis: 'Artifacts', value: scores?.artifacts ?? 0 },
  ];
  return (
    <div style={{ width: '100%', height: size, minHeight: 200 }} data-testid="score-radar">
      <ResponsiveContainer width="100%" height="100%" minHeight={200}>
        <RadarChart data={data} outerRadius="75%">
          <PolarGrid stroke="hsl(var(--border))" />
          <PolarAngleAxis
            dataKey="axis"
            tick={{ fontSize: 10, fontFamily: 'JetBrains Mono, monospace', fill: 'hsl(var(--foreground))' }}
          />
          <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
          <Radar
            dataKey="value"
            stroke="hsl(var(--primary))"
            fill="hsl(var(--primary))"
            fillOpacity={0.25}
            strokeWidth={2}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export const ScoreBars = ({ scores }) => {
  const items = [
    { label: 'Performance', value: scores?.performance ?? 0 },
    { label: 'Consistency', value: scores?.consistency ?? 0 },
    { label: 'Reliability', value: scores?.reliability ?? 0 },
    { label: 'Artifacts', value: scores?.artifacts ?? 0 },
  ];
  return (
    <div className="space-y-3" data-testid="score-bars">
      {items.map((i) => (
        <div key={i.label} className="space-y-1">
          <div className="flex items-center justify-between">
            <span className="label-eyebrow text-muted-foreground">{i.label}</span>
            <span className="mono text-sm font-bold">{i.value}</span>
          </div>
          <div className="score-bar">
            <div className="score-bar-fill" style={{ width: `${i.value}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
};

export const FitBadge = ({ value, size = 'lg' }) => {
  const color =
    value >= 80 ? 'bg-primary text-primary-foreground' :
    value >= 60 ? 'bg-foreground text-background' :
    value >= 40 ? 'bg-accent text-accent-foreground' :
    'bg-muted text-muted-foreground';
  const dims = size === 'lg' ? 'h-24 w-24 text-3xl' : size === 'md' ? 'h-16 w-16 text-xl' : 'h-10 w-10 text-sm';
  return (
    <div className={`inline-flex flex-col items-center justify-center mono font-bold ${color} ${dims}`}
         data-testid="fit-badge">
      <span>{value}</span>
      {size === 'lg' && <span className="label-eyebrow opacity-70 mt-0.5">FIT</span>}
    </div>
  );
};
